import { Controller } from "@hotwired/stimulus"
import { Dropdown } from "flowbite"

export default class extends Controller {
  static targets = [
    "dropdown",
    "dropdownTrigger"
  ]

  static values = {
    showOn: { type: String, default: "click" },
    placement: { type: String, default: "bottom" },
    offsetSkidding: { type: Number, default: 0 },
    offsetDistance: { type: Number, default: 10 }
  }

  connect() {
    this.dropdown = new Dropdown(
      this.dropdownTarget,
      this.dropdownTriggerTarget,
      {
        placement: this.placementValue,
        triggerType: this.showOnValue,
        offsetDistance: this.offsetDistanceValue,
        offsetSkidding: this.offsetSkiddingValue,
        onShow: () => {
          this.fitToViewport()
          this.dispatchEvent("show")
        },
        onHide: () => {
          this.clearViewportFit()
          this.dispatchEvent("hide")
        },
      }
    )
  }

  fitToViewport() {
    this.fitRafId = requestAnimationFrame(() => {
      const rect = this.dropdownTarget.getBoundingClientRect()
      const viewportHeight = window.innerHeight
      const buffer = 16

      if (rect.bottom > viewportHeight - buffer) {
        const maxHeight = Math.max(viewportHeight - rect.top - buffer, 50)
        this.dropdownTarget.style.maxHeight = `${maxHeight}px`
        this.dropdownTarget.style.overflowY = "auto"
      }
    })
  }

  clearViewportFit() {
    if (this.fitRafId) {
      cancelAnimationFrame(this.fitRafId)
      this.fitRafId = null
    }
    this.dropdownTarget.style.maxHeight = ""
    this.dropdownTarget.style.overflowY = ""
  }

  show() {
    this.dropdown.show()
  }

  hide() {
    this.dropdown.hide()
  }

  toggle() {
    this.dropdown.toggle()
  }

  disconnect() {
    this.dropdown.destroy()
  }

  dispatchEvent(action) {
    this.dropdownTarget.dispatchEvent(new CustomEvent(`dropdown:${action}`))
  }
}
